import Api from "../config/Axios";

// Wallet Issue List
export const getWalletIssueList = (token, user_id) => {
  const config = {
    headers: {
      Authorization: 'Bearer '+(token ? token : localStorage.getItem("token")),
      UserId: parseInt(user_id ? user_id : localStorage.getItem("user_id")),
    },
  };
  return Api.get("api/web/tasks/issues/list", config);
};

// Wallet Issue Approve
export const patchWalletIssueApproved = (beid, status) => {
  const config = {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("token"),
      UserId: localStorage.getItem("user_id"),
    },
  };
  // approve
  return Api.patch(`api/web/task/issue/${beid}/${status}`, beid, config);
};
